enum Brand {
  llamaya = 'llamaya',
  masmovil = 'masmovil',
}

export default Brand
